<span *ngIf="orderId" hidden>
  {{ order$ | async }}
</span>
<ng-container class="h-full">
  <div class="container flex flex-col">
    <div class="billing-header flex flex-row items-center justify-between">
      <div *ngIf="!editMode" class="flex shrink-0 flex-row items-center">
        <ion-icon [src]="textData.icon"></ion-icon>
        <h1>{{ textData.title }}</h1>
      </div>

      <div class="flex grow flex-row items-center justify-end">
        <ion-button fill="clear" (click)="cancel()">
          <ion-icon class="m-0 min-w-0" src="../../../../assets/icon/cross.svg"></ion-icon>
        </ion-button>
      </div>
    </div>

    <hr />

    <div class="form-content">
      <form
        *ngIf="!!address && (!addressesArray || !addressesArray?.length || writeAddress); else savedAddresses"
        [formGroup]="address"
        #ngForm="ngForm"
        id="addressForm"
        (ngSubmit)="onSubmit()"
        class="flex flex-col"
      >
        <div *ngIf="selectedAddress == 'shippingAddress' || onPickUpPointSelection" class="flex flex-col gap-5">
          <h2>¿A quién se lo enviamos?</h2>
          <div class="inputs-list gap-15 flex flex-col">
            <!-- Nombre completo y teléfono-->
            <div class="gap-15 flex flex-col xs:flex-row">
              <!-- Nombre completo -->
              <div class="flex flex-1 flex-col">
                <label for="recipient" class="form-label">Nombre completo <span>*</span></label>
                <input type="text" formControlName="recipient" autocomplete="recipient" placeholder="Bailongo" />
                <div class="error-container">
                  <ng-container *ngFor="let validation of validationMessages.recipient">
                    <div
                      class="error-message"
                      *ngIf="
                        address.get('recipient').hasError(validation.type) &&
                        (address.get('recipient').dirty || address.get('recipient').touched || ngForm.submitted)
                      "
                    >
                      <ion-icon name="information-circle-outline"></ion-icon>
                      <span translate>{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Teléfono -->
              <div class="flex flex-1 flex-col">
                <label for="phone" class="form-label">Teléfono <span>*</span></label>
                <input type="text" formControlName="phone" autocomplete="phone" placeholder="640555555" />

                <div class="error-container">
                  <ng-container *ngFor="let validation of validationMessages.phone">
                    <div
                      class="error-message"
                      *ngIf="
                        address.get('phone').hasError(validation.type) &&
                        (address.get('phone').dirty || address.get('phone').touched || ngForm.submitted)
                      "
                    >
                      <ion-icon name="information-circle-outline"></ion-icon>
                      <span translate>{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="flex flex-col gap-2.5">
              <div class="flex flex-col">
                <label for="email" class="form-label">E-mail <span>*</span></label>
                <input type="text" formControlName="email" autocomplete="email" placeholder="bailongo@gmail.com" />

                <div class="error-container">
                  <div
                    class="error-message"
                    *ngIf="
                      address.get('email').hasError('required') &&
                      (address.get('email').dirty || address.get('email').touched || ngForm.submitted)
                    "
                  >
                    <ion-icon name="information-circle-outline"></ion-icon>
                    <span translate>Campo obligatorio</span>
                  </div>

                  <div
                    class="error-message"
                    *ngIf="
                      !address.get('email').hasError('required') &&
                      (address.get('email').hasError('email') || address.get('email').hasError('pattern')) &&
                      (address.get('email').dirty || address.get('email').touched || ngForm.submitted)
                    "
                  >
                    <ion-icon name="information-circle-outline"></ion-icon>
                    <span translate>Correo inválido</span>
                  </div>
                </div>
              </div>

              <span class="email-message"> Te enviaremos la confirmación de tu pedido a este email. </span>
            </div>
          </div>
        </div>

        <hr *ngIf="selectedAddress == 'shippingAddress' || (onPickUpPointSelection && !editMode)" />

        <div *ngIf="!onPickUpPointSelection" class="flex flex-col gap-5">
          <h2 *ngIf="selectedAddress == 'shippingAddress'">¿Dónde lo enviamos?</h2>

          <div class="inputs-list flex w-full flex-col gap-5">
            <div *ngIf="selectedAddress != 'shippingAddress'" class="gap-15 flex w-full flex-col md:flex-row">
              <div class="flex flex-1 flex-col">
                <label for="organization" class="form-label">Nombre completo o empresa <span>*</span></label>
                <input
                  type="text"
                  formControlName="organization"
                  autocomplete="organization"
                  placeholder="Bailongo SLU"
                />

                <div class="error-container">
                  <ng-container *ngFor="let validation of validationMessages.organization">
                    <div
                      class="error-message"
                      *ngIf="
                        address.get('organization').hasError(validation.type) &&
                        (address.get('organization').dirty || address.get('organization').touched || ngForm.submitted)
                      "
                    >
                      <ion-icon name="information-circle-outline"></ion-icon>
                      <span translate>{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="flex flex-1 flex-col">
                <label for="taxId" class="form-label">DNI/NIE/CIF <span>*</span></label>
                <input
                  type="text"
                  validateTaxId
                  formControlName="taxId"
                  autocomplete="taxId"
                  placeholder="000000000"
                  (input)="fixTaxId()"
                />

                <div class="error-container">
                  <ng-container *ngFor="let validation of validationMessages.taxId">
                    <div
                      class="error-message"
                      *ngIf="
                        address.get('taxId').hasError(validation.type) &&
                        (address.get('taxId').dirty || address.get('taxId').touched || ngForm.submitted)
                      "
                    >
                      <ion-icon name="information-circle-outline"></ion-icon>
                      <span translate>{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="gap-15 flex flex-col xs:grid xs:grid-cols-3">
              <!--Calle-->
              <div class="col-span-2 flex flex-col">
                <label for="street" class="form-label">Nombre de la calle o vía <span>*</span></label>
                <input
                  type="text"
                  formControlName="street"
                  autocomplete="street-address"
                  placeholder="C/San Bailongo"
                  required
                />

                <div class="error-container">
                  <ng-container *ngFor="let validation of validationMessages.street">
                    <div
                      class="error-message"
                      *ngIf="
                        address.get('street').hasError(validation.type) &&
                        (address.get('street').dirty || address.get('street').touched || ngForm.submitted)
                      "
                    >
                      <ion-icon name="information-circle-outline"></ion-icon>
                      <span translate>{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!--Número-->
              <div class="flex flex-1 flex-col">
                <label for="number" class="form-label">Número <span>*</span></label>
                <input type="text" formControlName="number" placeholder="5" required />

                <div class="error-container">
                  <ng-container *ngFor="let validation of validationMessages.number">
                    <div
                      class="error-message"
                      *ngIf="
                        address.get('number').hasError(validation.type) &&
                        (address.get('number').dirty || address.get('number').touched || ngForm.submitted)
                      "
                    >
                      <ion-icon name="information-circle-outline"></ion-icon>
                      <span translate>{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="w-100 flex flex-row">
              <!--Piso-->
              <div class="flex flex-1 flex-col">
                <label for="floor" class="form-label"
                  >Escalera/piso/puerta
                  <ion-text color="medium">(Opcional)</ion-text>
                </label>
                <input formControlName="floor" type="text" autocomplete="street-address" placeholder="5º dcha" />
              </div>
            </div>

            <div class="gap-15 flex w-full flex-col xs:grid xs:grid-cols-3">
              <!--Codigo postal-->
              <div class="flex flex-col">
                <label for="postalCode" class="form-label">Código Postal <span>*</span></label>
                <input
                  (input)="setProvince()"
                  inputmode="numeric"
                  type="text"
                  formControlName="postalCode"
                  autocomplete="postal-code"
                  placeholder="04740"
                />

                <div class="error-container">
                  <ng-container *ngFor="let validation of validationMessages.postalCode">
                    <div
                      class="error-message"
                      *ngIf="
                        address.get('postalCode').hasError(validation.type) &&
                        (address.get('postalCode').dirty || address.get('postalCode').touched || ngForm.submitted)
                      "
                    >
                      <ion-icon name="information-circle-outline"></ion-icon>
                      <span translate>{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!--Ciudad-->
              <div class="flex flex-col">
                <label for="city" class="form-label">Ciudad <span>*</span></label>
                <input formControlName="city" type="text" placeholder="Roquetas de Mar" required />

                <div class="error-container">
                  <ng-container *ngFor="let validation of validationMessages.city">
                    <div
                      class="error-message"
                      *ngIf="
                        address.get('city').hasError(validation.type) &&
                        (address.get('city').dirty || address.get('city').touched || ngForm.submitted)
                      "
                    >
                      <ion-icon name="information-circle-outline"></ion-icon>
                      <span translate>{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!--Provincia-->
              <div class="flex flex-col">
                <label for="province" class="form-label">Provincia <span>*</span></label>
                <input readonly clearInput formControlName="province" type="text" placeholder="Almería" />

                <div class="error-container">
                  <ng-container *ngFor="let validation of validationMessages.province">
                    <div
                      class="error-message"
                      *ngIf="
                        address.get('province').hasError(validation.type) &&
                        (address.get('province').dirty || address.get('province').touched || ngForm.submitted)
                      "
                    >
                      <ion-icon name="information-circle-outline"></ion-icon>
                      <span translate>{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Dni en caso que el envío sea a Provincias extra peninsular -->
            <div *ngIf="dniIsRequired" class="flex flex-col" [ngClass]="!dniIsRequired ? 'ion-hide' : ''">
              <label for="dni" class="form-label">DNI/NIE/CIF <span>*</span></label>
              <input (input)="fixDNI()" validateTaxId formControlName="dni" type="text" required />

              <div class="error-container">
                <ng-container *ngFor="let validation of validationMessages.dni">
                  <div
                    class="error-message"
                    *ngIf="
                      address.get('dni').hasError(validation.type) &&
                      (address.get('dni').dirty || address.get('dni').touched || ngForm.submitted)
                    "
                  >
                    <ion-icon name="information-circle-outline"></ion-icon>
                    <span translate>{{ validation.message }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            addressesArray?.length >= 1 &&
            !userService.userG.isAnonymous &&
            (!defaultAddressIsSelected() || addressAction === 'add')
          "
          class="flex flex-col gap-5"
        >
          <hr />

          <ion-checkbox labelPlacement="end" class="w-fit" (ionChange)="setAsDefault = !setAsDefault">
            Establecer como datos de {{ selectedAddress === 'shippingAddress' ? 'envío' : 'facturación' }} por defecto
            para mis próximos pedidos. <br />
            <span>Puedes volver a cambiarlo desde “Mi cuenta > Mi perfil” o al hacer un pedido</span>
          </ion-checkbox>
        </div>

        @if (onPickUpPointSelection && !editMode) {
          <cpf-shipping-options
            id="shippingType"
            [onPickUpPointSelection]="onPickUpPointSelection"
            (shippingTypeChange)="shippingTypeChange($event)"
          ></cpf-shipping-options>
          <input type="text" formControlName="shippingType" hidden />
        }

        <hr />

        <div class="save-button-container flex flex-col">
          <div class="flex w-full flex-col justify-end gap-2.5 sm:flex-row">
            <button class="gray" (click)="cancel()">Cancelar</button>
            <button class="blue" id="save-button" type="submit" form="addressForm" [disabled]="address.invalid">
              {{ textData.button }}
              <ion-icon
                *ngIf="onPickUpPointSelection && !editMode"
                src="../../../../assets/icon/arrow-right.svg"
              ></ion-icon>
              <span *ngIf="orderId">&nbsp;y continuar</span>
            </button>
          </div>

          <div class="error-container w-full">
            <ng-container *ngFor="let validation of ShippingHelper.getPropertymessages('zone')">
              <div class="error-message" *ngIf="address.hasError(validation.type)">
                <ion-icon name="information-circle-outline"></ion-icon>
                <span translate>{{ validation.message }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-template #savedAddresses>
  <div class="container flex flex-col">
    @if (orderId && initialAddress) {
      <div class="flex flex-col items-end justify-between gap-2.5 xs:flex-row xs:items-start">
        <div class="flex w-full flex-col text-lg leading-[normal]">
          <span class="font-semibold">
            {{ initialAddress.organization || initialAddress.recipient }}
          </span>

          <span *ngIf="type === 'billing'">
            {{ initialAddress.taxId }}
          </span>

          <span *ngIf="type === 'shipping'"> {{ initialAddress.phone }} - {{ initialAddress.email }} </span>
          <span>
            {{ initialAddress.addressLine1 }}
          </span>
          <span> {{ initialAddress.postalCode }} - {{ initialAddress.city }} - {{ initialAddress.province }} </span>
        </div>

        <ion-button
          class="add-data flex w-fit flex-row items-center justify-center gap-2.5"
          color="dark"
          (click)="addNewAddress()"
        >
          <ion-icon name="add-outline"></ion-icon>
          <span>Añadir datos</span>
        </ion-button>
      </div>
    }

    <div class="flex flex-col gap-2.5">
      <ion-button
        *ngIf="!orderId"
        class="add-data flex w-fit flex-row items-center justify-center gap-2.5 self-end"
        color="dark"
        (click)="addNewAddress()"
      >
        <ion-icon name="add-outline"></ion-icon>
        <span>Añadir datos</span>
      </ion-button>

      <div class="flex max-h-96 flex-col gap-2.5 overflow-y-auto" (scroll)="appS.closeAllTooltips()">
        <ng-container *ngFor="let address of addressesArray; let i = index">
          <label
            for="{{ selectedAddress }}-{{ i }}"
            class="flex cursor-pointer flex-row items-center justify-between gap-2.5"
          >
            <input
              type="radio"
              id="{{ selectedAddress }}-{{ i }}"
              name="{{ selectedAddress }}"
              value="{{ selectedAddress }}-{{ i }}"
              [hidden]="addressesArray?.length === 1 && !orderId"
              [checked]="i === defaultAddressIndex"
              (click)="setDefaultAddress($event, address, i)"
            />
            <app-address-item
              [address]="address"
              [type]="type"
              [index]="i"
              [defaultCartAddressIndex]="defaultAddressIndex"
              (action)="userAddressAction($event)"
              class="w-full"
            ></app-address-item>
          </label>
        </ng-container>
      </div>
    </div>

    <div
      *ngIf="addressesArray?.length >= 1 && !defaultAddressIsSelected() && defaultAddressIndex >= 0"
      class="flex flex-col gap-5"
    >
      <hr />

      <ion-checkbox labelPlacement="end" class="w-fit" (ionChange)="setAsDefault = !setAsDefault">
        Establecer como datos de {{ selectedAddress === 'shippingAddress' ? 'envío' : 'facturación' }} por defecto para
        mis próximos pedidos. <br />
        <span>Puedes volver a cambiarlo desde “Mi cuenta > Mi perfil” o al hacer un pedido</span>
      </ion-checkbox>
    </div>

    <hr />

    <div class="save-button-container flex flex-col">
      <div class="flex w-full flex-row justify-end gap-2.5">
        <button class="gray" (click)="cancel()">Cancelar</button>
        <button [disabled]="defaultAddressIndex < 0" class="blue" (click)="onSubmit()">Guardar</button>
      </div>

      <div class="error-container w-full">
        <ng-container *ngFor="let validation of ShippingHelper.getPropertymessages('zone')">
          <div class="error-message" *ngIf="address.hasError(validation.type)">
            <ion-icon name="information-circle-outline"></ion-icon>
            <span translate>{{ validation.message }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
